<template>
    <loading-spinner v-if="loading" />
    <div v-else style="padding-bottom: 100px">

        <back-button/>

        <!-- IMAGE LEFT -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
                <v-img
                    eager max-height="250" contain
                    :lazy-src="imgPlaceholder" :src="programImg"
                />
            </v-col>

            <!-- NAME INFO RIGHT -->
            <v-col cols="12" md="6" class="pa-2">

                <v-row>
                    <v-col cols="12" class="routine-name text-center text-truncate">
                        {{ routineName }}
                    </v-col>
                </v-row>

                <v-row class="px-3 mt-5 box-title">
                    <v-col cols="6" class="border-right">
                        {{ $tc('common.minutes', 2) }}
                        <div class="box-description text-truncate">
                            {{ routineDuration }}
                        </div>
                    </v-col>
                    <v-col cols="6">
                        {{ $tc('common.blocks', 2) }}
                        <div class="box-description">
                            {{ blocks.length }}
                        </div>
                    </v-col>
                </v-row>
            </v-col>

            <!-- BLOCKS -->
            <v-col cols="12" class="pa-2">
                <routine-blocks readonly :defaultBlocks="blocks"/>
            </v-col>
        </v-row>

    </div>
</template>

<script>

import RoutineBlocks from '@/components/coach/routines/RoutineBlocks'
import {db} from "@/utils/Firebase";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import BackButton from "@/components/common/BackButton";
import {clearBlocksAssignedRoutine} from "@/utils/Exercises";

export default {
    components: {BackButton, LoadingSpinner, RoutineBlocks},
    data() {
        return {
            program: null,
            loading: false,
        }
    },
    computed: {
        programId(vm = this) {
            return vm.$route.params.uid || null
        },
        routineId(vm = this) {
            return vm.$route.params.id
        },
        programImg(vm = this) {
            return vm.program?.img || vm.imgPlaceholder
        },
        routine(vm = this) {
            return vm.program?.assignedRoutines[vm.routineId] || null
        },
        routineName(vm = this) {
            return `${vm.$t('programs.routine_name')} ${Number(vm.routineId || 0) + 1}`
        },
        blocks(vm = this) {
            return clearBlocksAssignedRoutine(vm.routine?.blocks || [])
        },
        routineDuration(vm = this) {
            if (!vm.routine) return vm.$t('common.not_available_short')
            let minutes = 0

            vm.routine.blocks.forEach(block => {
                block.exercises.forEach(exercise => {
                    minutes += exercise.config && exercise.config.sets.length || 0
                })
            })

            let minutesAdded = Number(minutes * 1.3).toFixed()
            if (Number(minutes) === Number(minutesAdded)) return minutes
            return `${minutes} - ${minutesAdded}`
        },
    },
    async mounted() {
        const vm = this
        await vm.loadProgram()
    },
    methods: {
        async loadProgram() {
            const vm = this
            vm.loading = true
            let programRef = await db.collection('programs').doc(vm.programId).get()
            vm.program = programRef.data()
            vm.loading = false
        }
    },
}
</script>

<style scoped>


.container-top-button {
    position: fixed;
    top: 80px;
    right: 30px;
    flex-direction: row;
    display: flex;
    align-items: center;
}

.divider {
    margin-left: 40%;
    margin-right: 40%;
    color: #c5c5c5;
}

.routine-name {
    font-size: 30px;
    color: #333333;
    font-weight: bold;
    margin-left: 5%;
}

.created_by {
    font-size: 15px;
    color: var(--v-secondary-base);
    margin-left: 5%;
}

.box-title {
    font-size: 13px;
    color: #707070;
    text-align: center;
}

.box-description {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
}

.border-right {
    border-right: 1px solid #C5C5C5;
}

.equipments-title {
    font-size: 15px;
    color: #707070;
    text-align: center;
}

.equipments {
    font-size: 15px;
    color: #707070;
    margin-left: 1px;
}

.block-title {
    background-color: #CCFF99;
    font-size: 17px;
    color: #333333;
    padding: 5px 0px;
}

.exercise-img {
    background-position: 50% 50%;
    background-size: cover;
}

.exercise-name {
    font-size: 15px;
    color: #333333;
}

.exercise-category {
    font-size: 11px;
    color: #707070;
}

.exercise-repeat {
    font-size: 11px;
    color: #707070;
}

.exercise-equipments {
    font-size: 11px;
    color: #707070;
}

</style>